import { useEffect } from 'react'
import { useAppSelector } from '../../app/hooks'
import { useDispatch } from 'react-redux'
import { fetchActiveDossier } from '../../features/dossier/dossierThunks'

const useUserProfile = () => {
  const dispatch = useDispatch()
  const debug = process.env.REACT_APP_DEBUG === 'true' ? true : false
  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  // =======================
  // Selectors
  // =======================
  const { coords } = useAppSelector((state) => state.userLocation)
  const {
    profile,
    loading: profileLoading,
    error: profileError,
  } = useAppSelector((state) => state.user)
  const {
    data: zone,
    loading: zoneLoading,
    error: zoneError,
  } = useAppSelector((state) => state.zone)
  const {
    data: dossier,
    loading: dossierLoading,
    error: dossierError,
  } = useAppSelector((state) => state.dossier)

  // =======================
  // Effects
  // =======================
  useEffect(() => {
    dispatch(fetchActiveDossier())
  }, [])

  return {
    profile,
    zone,
    dossier,
    coords,
    loading: profileLoading || zoneLoading || dossierLoading,
    error: profileError || zoneError || dossierError,
    debug,
    debugP2,
  }
}

export default useUserProfile
